const Images = {
  // logo: new URL("./images/Logo.png", import.meta.url).href,
  arrowBack: new URL("./icons/Vector.png", import.meta.url).href,
  eyeF: new URL("./icons/eye-slash.png", import.meta.url).href,
  eyeT: new URL("./icons/eye.png", import.meta.url).href,
  susSignIn: new URL("./icons/setpass.png", import.meta.url).href,
  error: new URL("./icons/info-circle.png", import.meta.url).href,
  ImgSliderDetails: new URL(
    "./images/ProductDetails/productdetails.png",
    import.meta.url
  ).href,
  ImgUser: new URL("./images/ProductDetails/imguser.png", import.meta.url).href,
  ImgUser1: new URL("./images/ProductDetails/imgUser1.png", import.meta.url)
    .href,
  ImgRating1: new URL("./images/ProductDetails/Rating1.png", import.meta.url)
    .href,
  ImgRating: new URL("./images/ProductDetails/Rating.png", import.meta.url)
    .href,
  slider2: new URL(
    "./images/ProductDetails/backside-detail.png",
    import.meta.url
  ).href,
  slider3: new URL("./images/ProductDetails/info-detail.png", import.meta.url)
    .href,
  slider4: new URL("./images/ProductDetails/info-detail.jpg", import.meta.url)
    .href,
  slider5: new URL("./images/ProductDetails/font-detail.png", import.meta.url)
    .href,
  slider6: new URL(
    "./images/ProductDetails/element-details.png",
    import.meta.url
  ).href,
  LogoMart: new URL("./images/YourOrder/LogoMart.png", import.meta.url).href,
  // icon
  IconHeart: new URL("./icons/heart-white.png", import.meta.url).href,
  IconStar: new URL("./icons/Rating_Star.png", import.meta.url).href,
  InconUp: new URL("./icons/arrow-up.png", import.meta.url).href,
  // IconShopping: new URL("./icons/shopping-cart.png", import.meta.url).href,
  IconSearch: new URL("./icons/search-normal.png", import.meta.url).href,
  IconArrowDown: new URL("./icons/arrow-down.svg", import.meta.url).href,
  IconArrowDownGray: new URL("./icons/arrow-down-gray.png", import.meta.url)
    .href,
  IconArrowRight: new URL("./icons/Icon-right.png", import.meta.url).href,
  IconCurrentSlide: new URL("./icons/Rectangle-660.png", import.meta.url).href,
  IconNextSlide: new URL("./icons/6.png", import.meta.url).href,
  IconClock: new URL("./icons/clock.png", import.meta.url).href,
  IconRightBlack: new URL("./icons/arrow-right-1.png", import.meta.url).href,
  IconRightWhite: new URL("./icons/arrow-right.svg", import.meta.url).href,
  IconLeftBlack: new URL("./icons/arrow-left.png", import.meta.url).href,
  IconClose: new URL("./icons/icon-close.png", import.meta.url).href,
  IconTrashWhite: new URL("./icons/trash-white.png", import.meta.url).href,
  IconTrashBlack: new URL("./icons/trash-black.png", import.meta.url).href,
  IconFind: new URL("./icons/icon-find.png", import.meta.url).href,
  IconMore: new URL("./icons/more.jpg", import.meta.url).href,
  IconFavorite: new URL("./icons/heart.svg", import.meta.url).href,
  Edit: new URL("./icons/editRv.png", import.meta.url).href,
  Check: new URL("./icons/Check.png", import.meta.url).href,
  Ticket: new URL("./icons/ticket-discount.jpg", import.meta.url).href,
  Seemore: new URL("./icons/seeMore.png", import.meta.url).href,
  nextBlack: new URL("./icons/Icon-next-black.png", import.meta.url).href,
  arrowDownBlack: new URL("./icons/arrowDown.png", import.meta.url).href,
  trash: new URL("./icons/trash.png", import.meta.url).href,
  minusCart: new URL("./icons/minusDetail.png", import.meta.url).href,
  plusCart: new URL("./icons/plusCart.png", import.meta.url).href,
  iconLocation: new URL("./icons/icon-location.png", import.meta.url).href,

  successfullSignup: new URL("./icons/successfull.png", import.meta.url).href,
  // customer image
  Customer1: new URL("./images/review/customer1.png", import.meta.url).href,
  Success: new URL("./images/review/success.png", import.meta.url).href,

  // checkout image
  Master: new URL("./images/checkout/master.png", import.meta.url).href,
  Ippay: new URL("./images/checkout/ippay.png", import.meta.url).href,
  Visa: new URL("./images/checkout/visa.png", import.meta.url).href,

  // notfound
  NotFound: new URL("./images/notfound/NotFound.png", import.meta.url).href,
  Next: new URL("./icons/Prev.jpg", import.meta.url).href,
  Prev: new URL("./icons/Next.jpg", import.meta.url).href,

  // map
  gps: new URL("./icons/gps.png", import.meta.url).href,
  gps2: new URL("./icons/location-add.png", import.meta.url).href,
  gps3: new URL("./icons/gps3.png", import.meta.url).href,
  btngps: new URL("./icons/ButtonsGPS.png", import.meta.url).href,
  address: new URL("./icons/address.png", import.meta.url).href,
  location: new URL("./icons/location-map.png", import.meta.url).href,
  driver: new URL("./icons/driver.png", import.meta.url).href,

  // activities
  timer: new URL("./icons/timer.png", import.meta.url).href,
  emptyActivities: new URL("./icons/activities.png", import.meta.url).href,
  // youroder
  yourorder: new URL("./images/YourOrder/youroder.png", import.meta.url).href,
  yourorder2: new URL("./images/YourOrder/yourorder2.png", import.meta.url)
    .href,
  codeorder: new URL("./images/YourOrder/code.png", import.meta.url).href,
  timeorder: new URL("./images/YourOrder/time.png", import.meta.url).href,
  kgorder: new URL("./images/YourOrder/kg.png", import.meta.url).href,
  // booking
  shipper: new URL("./images/booking/shipper.png", import.meta.url).href,
  bookingDefault: new URL(
    "./images/booking/booking-default.png",
    import.meta.url
  ).href,
};
export default Images;
